enum PaymentType {
    SinglePayment = "SINGLE_PAYMENT",
    ScheduledPayment = "SCHEDULED_PAYMENT",
}
export default PaymentType